import { ContentfulImageAPI } from '@toasttab/shared/src/utils/contentfulUtils'

export const buildVideo = (props: any) => {
  if (props.vidyardId || (!props.videoAsset && !props.animation)) {
    let imageUrl =
      props.previewAsset &&
      props.previewAsset.file &&
      props.previewAsset.file.url
    if (imageUrl && !imageUrl.includes('http')) {
      imageUrl = `https:${imageUrl}`
    }
    return {
      typeHandle: 'video',
      classes: '',
      vidyardId: props.vidyardId,
      sectionHeading: props.label,
      imageClasses: '',
      image: props.previewAsset
        ? [
            {
              url: imageUrl,
              optimizedImages: {
                src: '',
                srcset: '',
                srcsetMaxWidth: '',
                srcsetAvif: '',
                placeholderBox: '',
                placeholderImage: '',
                maxSrcsetWidth: '',
                srcAvif:
                  imageUrl +
                  ContentfulImageAPI.transformImageAvif({
                    extension: props.previewAsset.file.contentType
                  })
              },
              lazyLoad: true,
              extension: props.previewAsset.file.contentType
            }
          ]
        : null
    }
  } else {
    const animation = props.animation || props.videoAsset
    let imageUrl = animation?.file?.url
    if (!imageUrl.includes('http')) {
      imageUrl = `https:${imageUrl}`
    }
    const filename = animation?.file?.fileName || animation?.file?.filename
    const extension = filename.split('.')[1]
    return {
      typeHandle: 'videoAnimation',
      animation: {
        url: imageUrl,
        // todo - can we delete this? filename points to Cloudfront, not Contentful
        filename,
        extension
      }
    }
  }
}
